// extracted by mini-css-extract-plugin
export default {"productDescription":"Sea-z","featuredDescription":"Tea-z","description":"Uea-z","more":"Vea-z","descriptionSku":"Wea-z"};